import { Button, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap";
import React from 'react'
import { useAuth0 } from "@auth0/auth0-react";


const DropdownNav = ({ isHam, username }) => {
    const { logout } = useAuth0();

    return (
        <div>
            <UncontrolledDropdown group>
                <Button color="primary">
                    {username}
                </Button>
                <DropdownToggle
                    caret
                    color="primary"
                />
                <DropdownMenu>
                    <DropdownItem onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}>
                        Logout
                    </DropdownItem>
                </DropdownMenu>
            </UncontrolledDropdown>
        </div>
    )
}

export default DropdownNav
